export default {
  'reportTokens.title': 'Gestionar Tokens para Reportes',
  'reportTokens.showToken': 'Mostrar token',
  'reportTokens.accept': 'Aceptar',
  'reportTokens.traces': 'Trazas',
  'reportTokens.traces.description':
    'Consulte las trazas de peticiones del token de reportes seleccionado.',
  'reports.type.administration': 'Administración',
  'reports.type.process': 'Proceso',
  'reports.type.request': 'Solicitud',
  'reports.type.generic': 'Genérico',
  'reportTokens.type.administration': 'Administración',
  'reportTokens.type.process': 'Proceso',
  'reportTokens.type.request': 'Solicitud',
  'reportTokens.type.generic': 'Genérico',
  'reportTokens.type.powerbiconnector': 'Conector Power BI',
  'reportTokens.type.tableauconnector': 'Conector Tableau',
  'token.processInstance': 'Solicitud',
  'token.administration': 'Administración',
  'token.process': 'Proceso',
  'token.request': 'Solicitud',
  'token.generic': 'Genérico',
  'token.reportToken': 'Token para Reporte',
  'token.powerBIConnector': 'Conector de Power BI',
  'token.dynamicEntity': 'Entidad',
  'token.trace': 'Traza',
  'token.dataType': 'Tipo de Dato',
  'token.headers': 'Cabecera',
  'token.isSuccessfullyRequest': '¿Petición Satisfactoria?',
  'token.logs': 'Logs',
  'token.reportTokenId': 'Token de Reporte',
  'token.ip': 'IP',
};
